import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class SlackAuthTokenService {

  constructor(public rest: RestService) { }

  public slackAuthToken(code: string) {
    return this.rest.post('slackAuthToken', code, null);
  }

  getSlackIntegrationUrl() {
    return this.rest.get("getSlackIntegrationUrl", null);
  }

  public isSlackIntegrationAvailable() {
    return this.rest.get('checkSlackIntegrationStatus', null , null)
  }

}
